import styled from "styled-components"
import { responsive } from "buoy-theme"
import { BaseStyle } from "../common"

const SwitcherCards = styled.div`
  ${BaseStyle}
  max-width: 384px;
  flex-shrink: 2;
  height: auto;
  min-height: 100%;
  align-self: stretch;
  justify-content: start;
  ${responsive("display", "flex", "flex", "none", "none")};
  ${responsive("margin-right", "126px", "42px", "42px", "42px")};
`

export { SwitcherCards as default }


// WEBPACK FOOTER //
// ./assets/common/components/ProfileCards/components/SwitcherCards.js